import { gql } from "@apollo/client";
import { userDetails } from "../../../../../../../utils/commonQueryTypes";

export const DeleteJunction = gql`
  mutation DeleteJunction(
    $token: String!
    $junctionID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteJunction(
      token: $token
      junctionID: $junctionID
      user_details: $user_details
    )
  }
`;

export const AddJunction = gql`
  mutation AddJunction(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $input: CreateAtsJunctionsInput!
    $user_details: SubscribedUser!
  ) {
    AddJunction(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      input: $input
      user_details: $user_details
    )
  }
`;

export const UpdateJunction = gql`
  mutation UpdateJunction(
    $token: String!
    $junctionID: ID!
    $user_details: SubscribedUser!
    $input: UpdateAtsJunctionsInput!
  ) {
    UpdateJunction(
      token: $token
      junctionID: $junctionID
      user_details: $user_details
      input: $input
    )
  }
`;

export const ImportJunctionsMutation = gql`
  mutation ImportJunctions(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $input: ImportJunctionDetails!
    $user_details: SubscribedUser!
  ) {
    ImportJunctions(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      input: $input
      user_details: $user_details
    )
  }
`;

export const BulkAlterJunctionsMutation = gql`
  mutation BulkAlterJunctions(
    $token: String!
    $junctionID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: BulkAlterAtsJunctionsInput!
  ) {
    BulkAlterJunctions(
      token: $token
      junctionID: $junctionID
      customerID: $customerID
      user_details: $user_details
      input: $input
    )
  }
`;

export const ExportJunctions = gql`
  mutation ExportJunctions($token: String!, $customerID: ID!) {
    ExportJunctions(token: $token, customerID: $customerID)
  }
`;